const ITEMS = [
  "PEPE BUTT",
  "$PEPEBUTT",
  "THE THICCEST FROG ON SOLANA",
  "GM",
  "CHEEKS OUT FOR THE TIMELINE",
];

function Row({ ariaHidden }) {
  return (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`px-8 font-display text-2xl font-800 tracking-tight whitespace-nowrap uppercase sm:text-3xl ${
              i % 2 === 0 ? "text-neon" : "text-outline-faint"
            }`}
          >
            {item}
          </span>
          <span className="font-vt text-2xl text-punk">✕</span>
        </span>
      ))}
    </div>
  );
}

export default function MarqueeRibbon() {
  return (
    <div
      data-testid="marquee-ribbon"
      className="relative overflow-hidden border-y border-line bg-surface py-5"
    >
      <div className="animate-marquee flex w-max">
        <Row />
        <Row ariaHidden />
      </div>
    </div>
  );
}
